import { render, staticRenderFns } from "./AddRepairSetting.vue?vue&type=template&id=2d198140"
import script from "./AddRepairSetting.vue?vue&type=script&lang=js"
export * from "./AddRepairSetting.vue?vue&type=script&lang=js"
import style0 from "./AddRepairSetting.vue?vue&type=style&index=0&id=2d198140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports